module.exports = __webpack_public_path__ + "static/slika-4-5af4573d1c01e35b93b1cef748ab0583.png";